import styled from "@emotion/styled";

import Popover from "components/ui/popover/Popover";

export type ComboboxContentProps = {
  children: React.ReactNode;
  trigger?: React.ReactNode;
  open: boolean;
  setOpen: (open: boolean) => void;
};

export function ComboboxContent({ children, trigger, open, setOpen }: ComboboxContentProps) {
  return (
    <Popover
      trigger={trigger}
      open={open}
      onOpenChange={setOpen}
      side="bottom"
      align="start"
      contentPadding={0}
      avoidCollisions={false}
      hideArrow
      autoFocus={false}
      onOpenAutoFocus={(event) => {
        event.preventDefault();
      }}
    >
      <ContentWrapper>{children}</ContentWrapper>
    </Popover>
  );
}

const ContentWrapper = styled.div(({ theme }) => ({
  minWidth: 320,
  display: "flex",
  flexDirection: "column",
  backgroundColor: theme.colors.sysBackgroundDefault,
  width: "var(--radix-popover-trigger-width)",
  maxHeight: "var(--radix-popover-content-available-height)",
  padding: 8,
  borderRadius: 4,
  gap: 4,
}));
